var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29 20.26c7.547 0 11.675-6.255 11.675-11.68 0-.177-.004-.354-.012-.53A8.346 8.346 0 0 0 22 5.925a8.177 8.177 0 0 1-2.356.646 4.12 4.12 0 0 0 1.804-2.27 8.229 8.229 0 0 1-2.606.996A4.105 4.105 0 0 0 11.85 9.04a11.65 11.65 0 0 1-8.458-4.289 4.095 4.095 0 0 0-.556 2.064c0 1.424.725 2.681 1.826 3.417a4.072 4.072 0 0 1-1.858-.514v.053a4.105 4.105 0 0 0 3.291 4.023 4.107 4.107 0 0 1-1.853.07 4.108 4.108 0 0 0 3.833 2.852 8.23 8.23 0 0 1-5.096 1.757c-.327 0-.654-.019-.979-.057a11.612 11.612 0 0 0 6.29 1.844",
    fill: "currentColor"
  })));
};
export { SvgTwitter as ReactComponent };
export default __webpack_public_path__ + "84d60db2a6f04bdb5fdb86071e0599a8.svg";